import { render, staticRenderFns } from "./PosBind.vue?vue&type=template&id=579e61e2&"
import script from "./PosBind.vue?vue&type=script&lang=js&"
export * from "./PosBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports